import { Menu as MuiMenu, MenuProps as MuiMenuProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledMenu = styled(MuiMenu)<MuiMenuProps>(
  ({ theme: { spacing, palette, customVars } }) => ({
    '& .MuiPaper-root': {
      boxShadow: customVars.multiSelectMenuShadow,
      backgroundColor: palette.common.white,
    },
    '& .MuiMenuItem-root': {
      padding: spacing(1, 2.4),
      '&:hover, &:focus': {
        backgroundColor: palette.secondary.light,
      },
      '& .MuiSvgIcon-root': {
        marginRight: spacing(2),
      },
    },
  })
);
